import { fetchHistory } from '@/api/chat'

export const getBubbleHistory = async (bubble_id) => {
	if (!bubble_id) return { ok: false }
	try {
		await fetchHistory({ bubble_id })
	} catch (e) {
		console.error(e)
		const { error } = (e.response && e.response.data) || {}
		return { ok: false, error }
	}
}
